import { render, staticRenderFns } from "./ordersPrintOrder.vue?vue&type=template&id=36f0d122&scoped=true&"
import script from "./ordersPrintOrder.vue?vue&type=script&lang=js&"
export * from "./ordersPrintOrder.vue?vue&type=script&lang=js&"
import style0 from "./ordersPrintOrder.vue?vue&type=style&index=0&id=36f0d122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0d122",
  null
  
)

export default component.exports